import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { IExtraInfo } from '@app/activo2/vacations/components/total-vacations-detail/total-vacations-detail.interface';
import { ErrorMsgEnum } from '@app/components/error-msg/error-msg-enum';
import { VacationsService } from '@app/mot/services';
import { IMotStoreInfo } from '@app/mot/shared/interfaces/store-info.interface';
import { BaseComponentDirective } from '@app/shared/bases/base.component';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { get } from 'lodash';

@Component({
  selector: 'app-total-vacations-detail',
  templateUrl: './total-vacations-detail.component.html',
  styleUrls: ['./total-vacations-detail.component.scss']
})
export class TotalVacationsDetailComponent extends BaseComponentDirective implements OnInit, OnDestroy {
  extraInfo!: IExtraInfo;
  errorOcurred!: ErrorMsgEnum;
  subscriptions = new Subscription();
  isLoading = true;

  constructor(private router: Router, private vacationsService: VacationsService) {
    super();
    this.extraInfo = get(this.router.getCurrentNavigation(), 'extras.state.extraInfo');
  }

  ngOnInit(): void {
    this.getExtraInfo();
    this.initializeErrorHandling();
  }

  /**
   * This method is used to unsubscribe to all subscriptions
   */
  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  getExtraInfo() {
    this.isLoading = true;
    const vacationsExtraInfo$ = this.vacationsService.getExtraInfo(this.vacationsService.getSelectedYear());
    this.subscriptions.add(
      vacationsExtraInfo$.pipe(finalize(() => (this.isLoading = false))).subscribe((response: MSafeAny) => {
        this.extraInfo = response;
        this.filterNoObservationsStoreInfo();
      })
    );
  }

  /**
   * Remove the not stores that not has to show
   */
  filterNoObservationsStoreInfo() {
    this.extraInfo.storeInfo = this.extraInfo.storeInfo.filter((store) => {
      return this.hasObservations(store);
    });
  }

  /**
   * Check if Store info has to show on UI
   */
  hasObservations(store: IMotStoreInfo) {
    return (
      store.store?.renovation?.openRenovationDate ||
      store.store?.renovation?.closeRenovationDate ||
      store.observations?.general
    );
  }

  trackByItems(item: IMotStoreInfo) {
    return item;
  }

  /**
   * This method is used susbcribe to possible errors on backend request
   */
  private initializeErrorHandling() {
    this.subscriptions.add(
      this.vacationsService.onError$.subscribe((errorType) => {
        this.errorOcurred = errorType;
      })
    );
  }
}
